module.exports = __webpack_public_path__ + "img/sichakti_bagan_yes.c567ec94.png";